// extracted by mini-css-extract-plugin
export default {"root":"qmjPW2KLdx"};